import React, { useState, useMemo, useEffect } from "react";
import { createPortal } from "react-dom";

const Favorites = ({ regionsData }) => {
  const facilityData =
    typeof regionsData === "string"
      ? JSON.parse(regionsData)
      : regionsData;

  const [searchText, setSearchText] = useState("");
  const [selectedFacility, setSelectedFacility] = useState(null);

  // Flatten all facilities with region information
  const allFacilitiesRaw = useMemo(() => {
    if (!facilityData) return [];

    return facilityData.flatMap(region =>
      (region.rivers || []).flatMap(river => {
        if (river.facilities && river.facilities.length > 0) {
          return river.facilities.map(facility => ({
            facility_id: facility.id || facility.facility_id,
            facility_name: facility.facility_name,
            river_name: river.river_name,
            region_name: region.region_name, // Added region_name
            near_town: facility.near_town || "",
            slug: facility.facility_slug,
            post_id: facility.post_id,
            label: [
              facility.facility_name,
              river.river_name,
              facility.near_town
            ]
              .filter(Boolean)
              .join(", "),
            type: "facility", // Added type
          }));
        }
        return [];
      })
    );
  }, [facilityData]);

  // Remove duplicates
  const allFacilities = useMemo(() => {
    return [
      ...new Map(allFacilitiesRaw.map(item => [item.label, item])).values()
    ];
  }, [allFacilitiesRaw]);

  // Match only the displayed label text so suggestions stay exact.
  const suggestions = useMemo(() => {
    if (!searchText.trim()) return [];

    const searchLower = searchText.trim().toLowerCase();

    return allFacilities.filter(item =>
      item.label.toLowerCase().includes(searchLower)
    );
  }, [searchText, allFacilities]);

  const handleSelect = (item) => {
    console.log(item, "item");
    
    if (item.slug) {
      window.location.href = `/facility/${item.slug}`;
      return;
    }
    
    setSelectedFacility(item);
    setSearchText(item.label);
  };

  const handleChange = (value) => {
    setSearchText(value);
    if (value === "") {
      setSelectedFacility(null);
    }
  };

  const handleSearchSubmit = (value) => {
    const term = value.trim();
    if (term) {
      window.location.href = `/list/search/${encodeURIComponent(term)}`;
    } else {
      window.location.href = `/list/all`;
    }
  };

  const highlightText = (text, query) => {
    if (!query) return text;

    const regex = new RegExp(`\\b\\w*${query}\\w*\\b`, "gi");
    const parts = text.split(regex);
    const matches = text.match(regex);

    if (!matches) return text;

    let result = [];
    parts.forEach((part, index) => {
      result.push(part);
      if (matches[index]) {
        result.push(
          <strong key={index}>{matches[index]}</strong>
        );
      }
    });

    return result;
  };

  // Hide the original in-page container to remove/hide the old in-page search box
  useEffect(() => {
    const rootEl = document.getElementById("favorites");
    if (rootEl) {
      rootEl.style.display = "none";
    }
  }, []);



  const headerSearchEl = document.getElementById("header-search-root");

  return (
    <>
      {headerSearchEl && createPortal(
        <div className="search-input-wrapper">
          <input
            type="text"
            className="search-input"
            placeholder="Search rivers and facilities..."
            value={searchText}
            onChange={(e) => handleChange(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                handleSearchSubmit(searchText);
              }
            }}
          />
          <button 
            className="searchbar-button"
            onClick={() => handleSearchSubmit(searchText)}
          ></button>

          {searchText && !selectedFacility && suggestions.length > 0 && (
            <div className="search-suggestions">
              <div className="search-suggestions-wrap">
                {suggestions.map(item => (
                  <div
                    key={item.post_id}
                    className="suggestion-item"
                    onClick={() => handleSelect(item)}
                  >
                    {highlightText(item.label, searchText)}
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>,
        headerSearchEl
      )}
    </>
  );
};

export default Favorites;
